import { useMediaQuery } from '@mui/system';
import { resolveColorScheme } from '@tix-ticketing/ui-theme';
import { useThemeConfig } from 'lib/theme-config';

/**
 * The color scheme to render: the browser's light/dark setting when the tenant
 * ships both a light and a dark scheme, otherwise the tenant's one scheme.
 */
export function useColorScheme(): 'light' | 'dark' {
  const themeConfig = useThemeConfig();
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  return resolveColorScheme(themeConfig, prefersDark);
}